import enLocale from 'element-ui/lib/locale/lang/en'
const en_US = {
    dialog:{
        login:'Log In',
        goLogin:'Already have an account?',
        task:'Task',
        task2:'TASK',
        English:'English',
        India:'India',
        locked:'BLOCKED',
        noData:'No data yet,start playing now',
        toGuess:'BET NOW',
        EventName:'Event Name',
        GameName:'Game Name',
        BetingContent:'Beting content',
        BetAamount:'Bet amount',
        odds:'Odds',
        Revenue:'Revenue',
        status:'status',
        OrderNo:'Order No',
        BackToTop:'Back To Top'
    },
    team:{
        index:{
            MyPromotions:'My Commission',
            PerformanceInquiry:'Check Stats',
            PlayersInquiry:'Check Players',
            Teamperformance:'TEAM Performance',
            InviteFriends:'Invite Friends',
            enter:'Please enter player account',
            Rank:'Rank',
            promoteAccount:'promoteAccount',
            teamEnter:'Enter Player account of TEAM',
            teamEnter2:"Enter direct player's Name",
            _total:'Total Number of Player',
            _totalTEAM:'Total Number of TEAMS',
            player:'Number of player',
            _new:'New Additions of TEAM',
            _reg:'Daily New Register',
            increase:'Successful',
            reduce:'failure'
        },
        promotion:{
            record:'Commission withdrawal record',
            with:'Commission Withdrawal',
            green01:'Commission Withdrawal',
            green02:'Withdrawal record',
            green03:'Commission ratio',
            green04:'Promotion tutorial',
            inviteFriend:'Invite friends, you can',
            inviteFriend2:'earn cash bonus',
            inviteFriend3:'everyday',
            totalCom:'Total Commission',
            totalClaimed:'Commission ready to be claimed',
            todayInduction:'Equals to performance of TEAM + Direct Playe',
            MyID:'My Player ID',
            superID:'My Superior ID',
            MEMBER:'Total TEAM Members(New Members)',
            TEAMTODY:'TEAM Performance Today',
            PLAYERS:'Total Direct Players(New Players)',
            AFFILIATE:'Direct Players Performance Tody',
            TODAY:'Commission Today',
            YESTERDAY:'Commission Yesterday'
        },
        Inquiry:{
            affiliate:'Direct Players Performance',
            allperformance:'All performance',
            teamperformance:'TEAM performance',
            aff_Title:'Performance made by Players & TEAM are all your profit', 
            Rebate_Title:'Rebate ratio',
            SportSection:'Sport Section',
            LiveSection:'Live Section',
            SlotSection:'Slot Section',
            FishingSection:'Fishing Section',
            LotterySection:'Lottery Section',
            RebateAmount:'Rebate amount',
            Daily:'TEAM performance/Daily',
        },
        tutorial:{
          tit01:'how to promote to make money',
          tit02:'Where is the promotion invitation code?',
          tit03:'Where to check report and commission?',
          tit04:'How to calculate performance',
          tit05:'Requirement of deposit and withdrawl',
          tit06:'How to withdraw?',
          tit07:'How long for commission payout',
          desc01:'Scan QR code or click invitation link,choose to open it in the browser, register to download the game, and use your exclusive QR code event invitation link to promote it.',
          desc02:"Click to invite friends , and you will have your own exclusive QR code and registration link. The members registered in this way can become your direct players, and the downline members you invited will be your direct TEAM members.And many more, unlimited development can be achieved.",
          desc03:'TEAM page can check your TEAM members,TEAM company net win,direct members,direct affilaite performance,history total commission and avalible commission and so on.',
          desc04:'Performance refers to valid bets of players.for example,you invite one player,he win 500 and lose 300 on next bet,his performance is 800.',
          desc05:'Deposit in member center,withdraw is available when finish 1 time turnover.',
          desc06:'First,transfer from commission in TEAM page to wallet,then proceed to withdraw.choose the bank card you want to withdraw.bank card and name should be correct or will not withdraw successfully',
          desc07:'commission will credit daily.commission will be reset at 23:59pm every day.daily commission will payout refer to commission table base on how is the performance.',
          tabText01:'Commission calculation',
          tabText02:'Total commission',
          tabText03:'settlement time',
          tabMine01_1:'Direct agent commission=total commission ratio*direct affiliate performance',
          tabMine01_2:'TEAM commission=(total commission ratio-direct affiliates commission ratio)*TEAM performane',
          tabMine01_3:'A commission=(B1direct affiliate commission+B1 TEAM commission)+B2direct affiliate commission+B3diret affiliate commssion',
          tabMine01_4:'B1commission=C2 direct affiliates commission+C3 direct affilaites commssion',
          tabMine02:'total commission=direct affiliates commission+TEAM commission',
          tabMine03:'commission settled every day,commission based on daily performance.',
          proxyTips:'affiliate commission ratio table',
          perform:'performance Quota',
          thousand:'for every 10000',
          Rebate:'Rebate',
          Commission:'Rebate amount'
        }
    },
    newHome:{
        betnow:'Bet Now',
        login:'please log in first',
        play:'PLAY FOR REAL',
        sport:'SPORTS',
        slot:'Slots',
        SeeAll:'See All',
        lottery:'Lottery ',
        chess:'Rummy ',
        live:'Live Casino',
        Help:'Help',
        online:'Online Service',
        signup:'Sign Up',
        fastPayments:'Fast and secure payments',
        Populargames:'TRENDING NOW',
        games:'games',
        hotgames:'Hot Games',
        casinoTrust:'A Casino you can trust',
        NoMore:'No more matches',
        Cicket:{
            Matches:'Test Matches',
            empty:'Click on any price to add a bet!',
            empty_r:'Your bet slip is empty.',
            free:'auto receive latest odds',
            MyBets:'My Bets',
            BetingSlip:'Beting Slip',
            Momentum:'Momentum One Day Cup',
            ford:'FordTrophy 20/21',
            OneInternationals :'One Day Internationals ',
            TwentyBash :'Twenty20 Big Bash ',
            Others:'Others'
        }
    },
    header: {
        user:'Username',
        password:'Password',
        forget: 'Forgot your password?',
        login:'Login',
        register:'Join',
        signup:'Create A Free Account',
        verification:'Verification Code',
        RememberMe:'Remember Me',
        Deposit:'DEPOSIT',
        ScanLogin:'Scan Login',
        APPDownload:'Download APP',
        MemberCenter:'Member Center',
        mainAccount:'Main account',
        mineAccount:'My account',
        inEmail:'message',
        loginOut:'LOG OUT',
        Betting:'Betting Record',
        withdraw:'withdraw',
        deposit:'deposit',
        transaction:'Transaction Record',
        checkUsername:'enter username',
        checkPassword:'enter password',
        checkVrifyCode:'enter verification code',
        refresh:'Refreshed balance',
        seeMore:'check out more',
        hotDiscount:'Hit promos',
        customer:'Live Chat',
        downloadUrl:'Download APP',
        Eventhall:'promotion hall',
        Mobilebetting:'Mobilebet',
        Mobilebettin2:'scan QR download',
        Mobilebettin3:'Anti-hijacking and anti-jump',
        Home:'Home',
        Away:'Away',
        News:'News',
        Confirm:'Confirm',
        exitSuccessfully:'success log out',
    },
    notify:{
        success:'success',
        warning:'warning',
        error:'error',
    },
    
    login:{
        userPlace: 'password containing 6-12 letters, no., or a combination.',
        passwordPlace: 'password containing 6-12 letters, no., or a combination.',
        userRules1:'username not empty',
        userRules2:'password containing 6-12 letters, no., or a combination.',
        passwordRules:'password not empty',
        verificationRules:'verification not empty',
        finishContent:'complete filling',
        endTitle:"Don't have an account?",
        agentCode:'agentCode not empty'	
    },
    verificationRegister:{
        realName:'Please enter real name',
        qq:'Please enter QQ',
        wechat:'Please enter wechat',
        email:'Please enter email',
        phone:'Please enter phone no',
        password:'Please enter password',
        withdrawPassword:'Please enter withdraw password',
    },
    register: {
        FreeRegistration:'Free Registration',
        ConfirmPassword:'Confirm password',
        ConfirmPasswordPlace:'Please confirm the password again',
        open:'Open:',
        user:'Please enter username',
        userPlace: 'containing 6-12 letters、no. or combination',
        password:'Password:',
        passwordPlace: 'Please type again passWord',
        phone:'Phone no',
        phonePlace:'enter phone no.',
        phoneRules:'phone number not less than',
        phoneRules2:'Phone must be number',
        phoneTips:'Please provide correct phone no. to authenticate',
        agentCode:'Referral Code',
        agentPlace:'leave this field empty if no affiliates ID',
        verification:'Verification code:',
        verificationPlace:'enter verification code',
        rule:'I am at least 18 years old. I confirm that I’ve read and accpet the Terms & Conditions and Privacy policy',
        btn:'REGISTER NOW',
        agree:'I agree.',
        epeatPassword1:'confirm password not empty',
        epeatPassword2:'password does not match',
        phoneNumber1:'phone no. not empty',
        phoneNumber2:'enter correct phone no.',
        Returnsignin:'Sign up NOW',
        Terms:'11ic Terms & Conditions」',
        pleaseRead:'please read Privacy policy',
        realName:'Real name',
        realNamePlace:'enter real name(non-required)',
        realNamePlace_:'enter real name',
        realNameRules:'real name not empty',
        realNameRules2:'real name not less than',
        qq:'QQ',
        qqPlace:'enter QQ no.(non-required)',
        qqPlace_:'enter QQ no.',
        qqRules:'QQ not empty',
        qqRules2:'QQ not less than',
        wechat:'WeChat',
        wxPlace:'enter WeChat account(non-required)',
        wxPlace_:'enter WeChat account',
        realwxRules:'WeChat not empty',
        realwxRules2:'WeChat not less than',
        email:'Email',
        emailPlace:'enter Email(non-required)',
        emailPlace_:'enter Email',
        emailRulse:'Email not empty',
        emailRulse2:'Email not empty',
        emailRulse3:'enter correct Email',
        withdrawPassword:'withdraw password',
        withdrawPasswordPlace:'enter withdraw password (non-required)',
        withdrawPasswordPlace_:'enter withdraw password',
        withdrawPasswordRules:'withdraw password not empty',
        withdrawPasswordRules2:'withdraw password not less than',
        allRules:'- Digit or more than',
        Bit:'digit',
        Sentsuccessfully:'Sent successfully',
        phonecodePlace:'6 Digits OTP',
        sendingTip:'Veify'
    },
    agency:{
        title: 'affiliates program',
        affiliatesAgree: 'affiliates agreement',
        agencyLogin: 'affiliates login',
        agencyRegister: 'Register as affiliates'
    },
    nav:{
        APPDownload:'APP Download',
        home:'Home',
        cricket:'Cricket',
        CRICKET:'CRICKET',
        games:'Casino',
        live: 'Live Casino',
        rummy:'Rummy',
        sport:'Sport',
        slot: 'Slots',
        discounts: 'Promotions',
        agency:'Players',
        ColorLight:'Lottery',
        chess:'Card Game',
        Account:'Account',
        support:'Support',
        team:'Share',
        Fishing:'Fishing',
        vip:'vip',
        Commission:'Commission',
        Blog:'Blog',
        Affiliate:'Affiliate',
        Help:'Help',
        online:'Online Service'
    },
    
    walletlialog:{
        WALLET:'WALLET',
        Deposit:'Deposit',
        Withdraw:'Withdraw',
        WalletDetails:'details',
        MainAccount:'Main Wallet',
        Cancel:'close',
        NoDate:'No gaming account found',
        refreshsuccess:'Balance Refreshed'
    },
    discounts:{
        Promotions:'Promotions',
        details:'details',
        noDiscounts: 'No promos',
        discountsReceived: 'Claim bonus',
        checkPlatform:'select platform',
        checkMoney: 'Please enter amount',
        checkMoneyPlace:'enter game amount ',
        cancel: 'Cancel',
        confrim:'Confirm',
        checkBisnum:'enter bet slip no.',
        checkBisnum2:'enter betting deposit slip no.',
        needLoin:'log in to claim bonus',
        needLoin2:'log in to claim bonus',
        querylevel:'check tier status',
        queryresult:'Inquiry Center',
        account:'Username',
        currentlevel:'Current Tier',
        Totalcumulativebets:'Total amount betted',
        Accumulatedpromotionbonus:'total tier status bonus',
        Accumulatedsalary:'total monthly bonus',
        AccumulatedMonthlysalary:'total weekly bonus',
        Totalbetamountrequiredforpromotion:'Bets required for upgrade',
        loading:'loading',
        tips: 'Reminder',
        joinNow:'SEE MORE'
    },
    forget:{
        title: 'Forgot your password',
        RetrieveSMS:'SMS recovery',
        MailboxRetrieve: 'Email recovery',
        CustomerRetrieve:'Customer Support recovery',
        sendMsg:'Send verification code',
        checking: 'Verify',
        finish: 'Finished',
        userPlace:'Enter your username',
        phonePlace:'Enter bindphone no.',
        emailPlace:'Enter bindEmail',
        sendPhoneMsg:'send SMS verification code',
        sendEmailCode: 'Enter bindEmail',
        sendEmail:'send Email verification code',
        bindPhone:'Enter bindphone no.',
        bindEmail:'Enter bindEmail',
        verifyPlace:'enter verification code',
        tips:'',
        tips2:'SMS with Verification Code has been sent to your phone.',
        newpwdPlace:'enter new password',
        reNewpwdPlace: 'type new password again',
        check:'Verify',
        resetSuccess:'Pwd reset success!',
        celebrate:'Congrates! ',
        determine:'confirmed',
        CustomerService: 'contact Customer Support',
        sendAgain:'resend verification code',
        // second:'Resend after seconds'
    },
    mine:{
        welcome: 'Welcome',
        balance: 'balance',
        minecenter: 'MyCenter',
        AccountManagement:'Account Manage',
        amountManage: 'Funds manage',
        Betting: 'Bet records',
        welfare: 'Claim bonus',
        transaction: 'transaction:statement',
        myDiscount: 'My Promotion',
        safe: 'Account safety',
        inEmail: 'message',
        loginOut: 'Log out',
        friend:'Refer A Friend',
        Affiliates:'Players can register via any method',
        informationCenter:'News center',
        Claimedsuccessfully:'Claimed successfully! Congratulations You earn',
        beReset:'Reminder: If daily task reward do not claim ,it will be reset',
        title01:'Invitation Task',
        title02:'Deposit Task',
        title03:'Games Task',
        Complete:'Complete',
        EarnReward:'Earn reward',
        Invite:'Invite',
        PlayGame:'Play game',
        laest_D:{
            cancel_B:'Are you sure to cancel the deposit?',
            revoked:'Your application has been revoked!',
            Reminder:'Reminder : Multiple Request Will Deemed To Account Suspended',
            Friendly:'Friendly reminder',
            Youslip:'You still have unapproved deposits, please wait for approval or cancel your deposit slip',
            confirmed:'confirmed',
            no:'no',
            yes:'yes',
            orderNo:'orderNo',
            Date:'Date',
            Type:'Type',
            Amount:'Amount',
            ID:'ID',
            status:'Status',
            action:'Action'
         },
        center: {
            account: 'account',
            username: 'Username',
            balance: 'balance',
            money: 'INR',
            name: 'name',
            verification: 'Get Verified Now',
            phone: 'Phone',
            email: 'Email',
            draw: 'Fill in',
            wechat: 'WeChat',
            tips: 'Reminder',
            congratulations: 'congratulations',
            success: 'success',
            qqConfirm: 'QQ verify',
            qqrule: 'enter a vaild QQ',
            qqPlace: 'enter your QQ',
            wechatConfirm: 'WeChat verify',
            wechatrule: 'enter your WeChat',
            wechatPlace: 'enter your WeChat',
            cancel: 'Cancel',
            confrim: 'confirm'
        },
        capital:{
            account: 'Account statement',
            deposit: 'Deposit',
            latestDeposit:'Latest Deposit',
            ContinuePayment:'Continue Payment',
            revoke:'revoke',
            withdraw: 'withdraw',
            bankList: 'bank account manage',
            withdrawal: 'Withdraw Request',
            lockAmount: 'Locked Details',
            accountin: {
                balance: 'Balacne',
                refresh: 'refresh',
                accountBalance: 'main account',
                deposit: 'deposit',
                withdraw: 'withdraw',
                takeBack: 'takeBack',
                AvailBalance: 'available balance',
                mainBalance: 'main',
                money: 'INR',
                RMB: 'RMB',
                describe: 'No gaming account found',
                describe2: 'No game found',
                refreshSuccess: 'Success refreshed',
                takeBacking: 'taking back',
                takeBackError: 'TakeBack error',
                gameBalance:'Game account amount',
            },
            depositin: {
                deposit: 'deposit',
                nocheck:'No payment options',
                limit: 'Deposit Limit:',
                limit2: 'Single Limit:',
                money: 'INR',
                Previous:'Previous',
                Recharge:'Instant Recharge',
                returns:'return',
                Recharge1:'RECOMMENDED TOP UP AMOUNT',
                Recharge2:'PLEASE TOP UP',
                Recharge3:'TOP UP AMOUNT',
                Recharge4:'PLEASE ENTER TOP UP AMOUNT',
                choseBank: '请选择第三方支付银行',
                typeofpayment: 'Type of payment',
                bank:{
                    title1:'1st, Fill in the transfer form',
                    title2:'2rd, Complete and done',
                    title3:'Make sure deposit before submit',
                    copy:'Copy',
                    Bank:'Bank Name',
                    Beneficiary:'Account Name',
                    Account:'Account Number',
                    Cancel:'Cancel',
                    Next:'Next',
                    successTitle1:'Sent cancel deposit request',
                    successTitle2:'Inter bank transfer:deposit will reflect in your account 30 minutes after. If you didn’t receive the fund within 24 hours after you fund is processed, please contact Customer Support!',
                    orderNumber:'transaction no.',
                    DepositorName:'Depositor',
                    Amount:'Amount',
                    done:'Done',
                    dialogTitle:'Please confirm transfer information',
                    UP:'upload receipt',
                    Confirmed:'confirmed',
                    copysuccess:'success copied',
                    pleaseAmount:'enter deposit amount',
                    pleaseName:'enter depositor name',
                    pleaseImgUrl:'upload receipt',
                    subsuccess:'success',
                    suberr:'failed'

                },
                nobank:{
                    PayGate:'PayGate',
                    FEE:'Fee',
                    CollectionAccount:'Receiver QR Code',
                    copy:'Copy',
                    Cancel:'Cancel',
                    complete:'Next',
                    orderNumber:'transaction no.',
                    Submmit:'Time',
                    Amount:'Amount',
                    Transfer:'Transfer',
                    title1:'applicable for this only. Please check next transaction.',
                    title2:'Deposit request sent',
                },
                checkform:{
                    Depositlimit:'Deposit Limit',
                    Amount:'Amount',
                    DepositorName:'UTR/Reference No.',
                    UP:'Transaction Receipt',
                    UPtips:'Image size suggest: 1 MB Support formats: JPG, PNG, GIF, BMP',
                    chenkAmount1:'Please enter a positive integer',
                    chenkAmount2:'The deposit amount cannot be less than',
                    chenkAmount3:'The deposit amount cannot be more than',
                    UPmessage:'Upload successfully',
                    err1:'Upload image format is wrong!',
                    err2:'Upload voucher size cannot exceed 1MB!',
                    Transferamount: 'Transfer amount',
                    TransferUSDTAmount: 'You want transfer USDT amount',
                    RupeeAmount: 'Will approve rupee amount'
                }
            },
            withdrawalin: {
                title: 'withdraw amount',
                amountPlace: 'enter withdraw amount',
                refresh: 'refreshed balance',
                AvailBalance: 'Available Balance：',
                amount: 'Amount',
                tips: 'Allowable withdrawal more than {min} and avoid decimals',
                // tips: '(Allowable withdrawal more than_',
                // tips3: more than_ and avoid decimals)',
                withdrawPassword:'Withdraw password',
                choseBankCard: 'Select Bank',
                Please:'please Select Bank Name',
                loading: 'loading',
                addBankCard: 'add bank card',
                tips2: 'Reminder: need withdraw password and phone verification before withdraw',
                next: 'Next',
                diatitle: 'enter withdraw password',
                diaPlace: 'Please enter withdraw password',
                confrim: 'confirm',
                confrim1Title: 'No withdraw password, do you want set a password?',
                confrim2Title: 'Need phone no. verification before withdraw, verify now?',
                confrimTips: 'Reminder',
                confirmText: 'confirm',
                cancelText: 'Cancel',
                wpandmb2:'Please fill up mobile number and withdrawal pin before binding bank account',                
                wpandmb:'add bank account need phone number verification and set up withdrawl password,continue？',
                choseBank: 'choose a bank',
                choseAmount: 'withdrawl amount ',
                choseAmount2: 'more than ',
                noBalance: 'insufficient balance',
                noPoint: 'avoid decimals',
                nopwd: 'enter withdraw password',
                withdrawalSuccess: 'Request sent, wait for approval',
                refreshSuccess: 'Success refreshed'
            },
            bankListin: {
                title1: 'check bank lists',
                title2: 'Wthdrawal Bank Account',
                loading: 'loading',
                tips1: 'Contact Customer Support to delete bank account, Yes or No?',
                addBankCard: 'Wthdrawal Bank Account',
                bankUser: 'Card Holder',
                littleTips: 'Reminder',
                nameOnce: 'Card holder name must comply with the verified real name and can only be set once. Contact Customer Support to modify if needed',
                namePlace: 'enter card holder name',
                bankNum: 'Bank Account Number',
                bankTips: 'enter a vaild bank account no. or display error',
                bankPlace: 'enter bank account no.',
                bankName: 'Bank Name',
                PbankName: 'choose bank',
                bankNamePlace: 'enter bank name',
                subbranch: 'IFSC Code',
                subbranchPlace: 'enter the accounts bank branch',
                Mobile:'Mobile No.With Bank',
                Mobiletitle:'Must put the accounts bak phone no.',
                password: 'Withdraw password',
                passwordPlace: 'enter withdraw password',
                add: 'add',
                confirmTitle: 'Need withdraw password before binding bank account, do you want set a password?',
                confirmTips: 'Reminder',
                confirmText: 'confirm',
                cancelText: 'Cancel',
                Cancel:'cencel',
                OK:'confirmed',
                cantBank: 'Unable to bind bank account now ',
                addSuccess: 'Add success',
                Required:'not empty',
                bkNbrules:'Must 10-50 digits letters',
            },
            addUsdtcard: {
                addUsdt:'Add digital currency address',
				pageTitle: 'Digital currency address management',
				tips1: 'contact Customer Support to update phone number',
				tips2: 'no transaction password, do you want set a password?',
				tips3: 'Do you want set a password for your account safety?',
				personName: 'Card holder',
				personNamePlace: 'Please enter your name',
				currencyType: 'Currency type',
				currencyTypePlace: 'Please select currency type',
				depositAddress: 'Deposit address',
				depositAddressPlace: 'Please enter deposit address',
				phone: 'Phone number',
				phonePlace: 'Please enter phone number',
				phoneCode: 'Phone number verification code',
				phoneCodePlace: 'Please enter phone number verification code',
				withdrawPassword: 'Transaction password',
				withdrawPasswordPlace: 'Please enter transaction password',
                confirm: 'Confirm',
                addNow: 'Add now',
                sendCode:'Send verification code',
                sendCodeTip:'S)',
                TRC20: 'TRC20 digital currency',
                ERC20: 'ERC20 digital currency',
                HECO: 'HECO digital currency',
                OMNI: 'OMNI digital currency',
                phoneBindTip: 'You have not bound your phone number, please bind your phone number first',
                tipsError: 'Unknown system exception',
                passwordTips: 'The transaction password has not been set, do you want to go to set it?',
                safteyTips: 'To ensure account security, do you want to go and set it up?',
			}, 
            withdrawListlis: {
                loading: 'loading',
                search: 'Search',
                time: 'Time',
                amount: 'Amount',
                status: 'Status',
                bankName: 'bank name',
                bankNumber: 'bank account no.',
                remark: 'Remark',
                statusAll: 'All',
                applying: 'applying',
                payment: 'processing',
                success: 'success',
                reject: 'declined'
            },
            lockAmountin: {
                rechargeLock: 'deposit locked',
                allStates: 'all',
                lockIn: 'lock in',
                Unlocked: 'unlocked',
                Cancelled: 'cancelled',
                order: 'Order no.',
                principal: 'capital',
                lockInAmount: 'locked amount',
                targetFlow: 'turnover target',
                flowComple: 'turnover completed',
                lockStatus: 'lock status',
                handle: 'operate',
                deblocking: 'unlock',
                discountsLock: 'promotion lock',
                allPlatform: 'All platforms',
                mainAccount: 'main account',
                bonusName: 'bonus title',
                bonusType: 'bonus type',
                platform: 'platform',
                bonusLockStatus: 'bonus locked status',
                deblockingSuccess: 'unlocked'
            },
        },
        betlist: {
            allPlatform: 'All platforms',
            bizNo: 'bet slip no.',
            platformCode: 'Platform code',
            gameType: 'Game type',
            betAmount: 'Bet amount',
            betAmount2: 'Bet amount:',
            betflow: 'Vaild amount',
            betflow2: 'Vaild amount:',
            resultAmount: 'Profits',
            resultAmount2: 'Profits:',
            betTime: 'Bet time',
            createTime: 'Settletime',
            selectTime: 'Choose time slot',
            nobetlist:'No bet record!',
            all:'Total ',
        },
        getBonus: {
            title:'Bonus Claim Center',
            AccumulatedWithdrawalAmount:'Accumulated Withdrawal Amount',
            AccumulatedBonus:'Accumulated bonus',
            canDraw:'Can receive',
            ongoing:'In progress',
            Finished:'Finished',
            refresh:'One-click refresh',
            noData:'No relevant data temporarily',
            bonusName:'Promotion name',
            bonusMoney:'Concession amount',
            targetBetflow:'Withdrawal required cash flow',
            pendingflow:'Pending flow',
            DistributionTime:'Distribution time',
            handle:'Operation',
            draw:'Receive',
            total:'Total {num} records',
            totalPage:'Total {num} pages',
            nowPage:'Current',
            previousPage:'Previous page',
            nextPage:'Next page',
            success:'Congratulations, you received the success! ',
            targetFlow:'Target Flowwater {targetAmount}',
            finishedFlow:'The completed flow {validAmount}'
        },
        billDetail: {
            toady: 'Today',
            yesterday: 'Yesterday',
            finalWeek: 'Last 7 days',
            finalMonth: 'Last 30 days',
            allType: 'all',
            SystemTransfer: 'system adjustment',
            RepaidDeposit: 'Make deposits',
            withdrawals: 'quick withdraw',
            SwitchToGame: 'Import to game',
            GameOut: 'Export from game',
            discounts: 'Promotion Bonus',
            ManualDeposit: 'Manual Deposit',
            ManualRemoval: 'Manual Withdraw',
            Betting:'Betting',
            Payout:'Payout',
            applying:'applying',
            transNo: 'order no.',
            orderName: 'order title',
            orderTime: 'time',
            payType: 'transaction type',
            amount: 'Amount',
            status: 'Status'
        },
        myDiscountin: {
            title: 'My Promotion',
            allType: 'All type',
            applying: 'applying',
            successfulCollection: 'claimed success',
            finishFlow: 'turnover completed',
            cancel: 'decline',
            Clearance: 'Clearance',
            Unclaimed: 'Unclaimed',
            noPrize: 'not awarded',
            noOffer: 'no promos',
            clickApply: 'click to apply',
            discountItem: {
                needLaveBetflow: 'Turnover allowed to cash out on THB platform',
                needLaveBetflow2: 'Turnover allowed to cash out on THB platform',
                flowDone: 'reached turnover',
                loseEfficacy: 'Invalid'
            }
        },
        safein: {
            realName:'Real name',
            email:'Email address',
            phone:'Phone',
            bankcard:'Bank Account',
            emailTitle: 'Email verification',
            emailSubTitle: 'For the purpose of password recovery and identify',
            nameTitle: 'real name verification',
            nameSubTitle: 'confirm personal details',
            phoneTitle: 'binding your phone no.',
            vipTitle: 'Login password',
            codeTitle: 'Withdraw Password',
            revisecodeTitle: 'revise withdraw password',
            codeSubTitle: 'protect your account',
            bankTitle: 'bank account{length}',
            management:'manage',
            revise: 'revise',
            authen: 'verify',
            set: 'set',
            receive: 'claim',
            start: 'activate',
            customer: 'contact Customer Support to modify',
            sendcode:'Sent verification code',
            alterAction:'change{str}contact livechat,continue？',
            confirmText: 'confirm',
            cancelText: 'Cancel',
            common1:'Please complete phone no. verification',
            common2:'Success! bonus release please check My Promotion',
            common3:'Unknown system error ',
            Resend:'seconds Resend after',
            Congratulations:'Congratulations',
        },
        verifyEmail: {
            title:'Bind Email address',
            subTitle1:'enter Email address',
            subTitle2:'enter verification code',
            sendcode:'send verification code',
            suffix: 'seconds Resend after',
            cancel:'Cancel',
            confrim: 'confirm',
            tips:'1.An email with Verification Code has been sent to your phone. If not received, please click send verification code.',
            tips2:'2.Note: the email might be mistaken for spam; pls also check the spam folder',
            emailHadSend:'Email Sent ',
            emailConfrim:'Email verification',
        },
        verifyName:{
            title:'real name and ID verification',
            subTitle1:'enter real name',
            subTitle2:'enter ID no.',
            cancel:'Cancel',
            confrim: 'confirm',
            tips:'Real name and ID verification to protect your legal rights and account safety',
            nameConfrim:'real name verification',
        },
        verifyPhone:{
            title:'Bind phone no.',
            subTitle1:'enter phone no.',
            subTitle2:'enter verification code',
            sendcode:'send verification code',
            suffix: 'Resend after ____ seconds',
            cancel:'Cancel',
            confrim: 'confirm',
            modify:"modify",
            modifyph:"modify phone no.",
            tips:'The above information is used to recover your account if you forget your username and password.',
            mileHadSend:'SMS sent',
            phoneConfrim:' phone no. verification ',
        },
        loginPassword:{
            title:'Change login password',
            subTitle1:'enter old password',
            subTitle2:'enter new password',
            subTitle3:'confirm new password',
            cancel:'Cancel',
            confrim: 'Change',
            tips:'Remark: keep password confidential. If you forgot your password, you may use password recovery tools or contact Customer Support',
            pleaseLogin:'log in again',
            oldpwdError:'Old password error format',
            pwdError: 'New password error format',
            pswIsChange:'change login password'
        },
        setPassword:{
            title:'Set withdraw password',
            subTitle1:'enter verified phone no.',
            phoneFirst: 'please verify your phone no.',
            subTitle2:'enter verification code',
            subTitle3:'enter withdraw password',
            subTitle4:'confirm new password',
            sendcode:'send verification code',
            suffix: 'Resend after ____ seconds',
            cancel:'Cancel',
            confrim: 'confirm',
            tips:'Remark: keep password confidential. If you forgot, please contact Customer Support' ,
            mileHadSend:'SMS sent',
        },
        changePassword:{
            title:'change withdraw password',
            subTitle1:'enter verified phone no.',
            phoneFirst: 'enter withdraw password',
            subTitle2:'enter verification code',
            subTitle3:'enter old withdraw password',
            subTitle4:'enter new withdraw password',
            subTitle5:'confirm new withdraw password',
            sendcode:'send verification code',
            suffix: 'Resend after ____ seconds',
            cancel:'Cancel',
            confrim: 'confirm',
            tips:'Remark: keep password confidential. If you forgot, please contact Customer Support',
            mileHadSend:'SMS sent',
        },
        email:{
            title:'Message',
            mineMsg: 'My Message',
            newMsg: 'Latest  News',
            hasRead: 'Read Message',
            noMsg: 'No message' ,
            del:'delete',
            sendMsg:'Send New Message',
            msgType:'Message type：',
            please:'select',
            pleaseCheck:'select question type',
            mine:'Main Subject Line:',
            minePlease: 'input a subject line',
            content: 'content:',
            contentPlaese:'input content',
            send:'send',
            question1:'withdraw and deposit',
            question2:'Promotions',
            question3:'Game related',
            question4:'other question',
            question5:'Suggestion',
            question6:'Complaint',
            checkInfo:'Delete Selected Messages',
            delSuccess:'Deleted success',
            submitSuccess:'submit success',
            finishContent:'complete filling in'
        }
    },
    game:{
        playNow:'PLAY NOW',
        comingSoon:'coming soon',
        realMoney: 'real money',
        try: 'free bet',
        noData:'no matching results'
    },
    slot:{
        gameSearch:'search game',
        reset:'reset',
        mineCollect: 'My collection',
        mineCollect2: 'No collection',
        gameLobby: 'Game Lobby:',
        gameTypes:'Game type',
        hotGame:'Bit Hits',
        newGame:'Top Hits',
        recommend: 'Recommend',
        all:'all',
        PrizePoolGame:'Jackpot slots',
        classicGame:'classic',
        xxl:'Russian Tetris',
        electricHorn: 'video slots',
        line:'line',
        pleaseEnter:'search for game',
        add:'add to favorite',
        addSuucess:'add to favorite success',
        cancelSuccess:'remove from favorit',
        hadCollect:'collected',
        late:'try again later',
        noLogin:'Add to favorite after login',
        hotGameRank:'Popular games ranking',
        loading: 'loading',
        gogame: 'enter a game',
        describe: 'check after login',
        title1:'Recently Viewed',
        title2:'you may also like',
    },
    footer:{
        webSlogan:'CONTACT US',
        MENU:'Menu',
        INFORMATION:'Information',
        Game:'GAME PROVIDERS',
        Introduction:'Be a part of a winning TEAM! Join the 11ic rewarding affiliate program and earn money for each of your referred customers. The more playersyou refer, the higher you move up through the revenue share ranks.',
        Introduction02:'For further information or inquiries associated with gambling, refer to our Responsible Gaming Guide.',
        Introduction03:'Any participants who are underage is strictly prohibited.',
        Certificates:'OUR APP',
        BestGame:'FOLLOW US!',
        SecurePayment:'Services',
        terms:'Terms and Conditions',
        copyBrand:'COPYRIGHT © 2003-{year} 11ic (International) Ltd.',

    },
    form: {
        IFSC:'IFSC must be a combination of 8-12 digits and letters',
        checkMoney1:'enter amount',
        checkMoney2:'format error',
        checkMoney3:'amount cannot be 0',
        //
        checkWithdraw:'enter withdraw password',
        //
        checkRealname:'enter real name',
        /**Verify bank card*/
        checkBankNumber1:'enter bank account',
        checkBankNumber2:'bank card format error',
        /** Verify branch*/
        checkBranch:'enter the accounts bank branch',
        /** Check email */
        checkEmail1:'enter Email address',
        checkEmail2:'Email format error',
        /** Verify ID */
        checkCard1: 'enter ID no.',
        checkCard2: 'ID no. format error',
        /**Check mobile phone number*/
        checkPhone1: 'enter phone no.',
        checkPhone2: 'enter vaild phone no.',
        /** verify password */
        checkPassword:'enter password',
        /** Verify the password */
        checkConfirm1: 'enter password again',
        checkConfirm2: 'password does not match',
        /** Verify the original password to confirm the password */
        checkConfirms: 'old and new password are the same',
        /**Verify verification code*/
        checkVerifiCode1: 'verification code not empty',
        checkVerifiCode2: 'verification code format error',
        /** Verify account */
        checkUsername1: 'enter username',
        checkUsername2:'password containing 6-12 letters, no., or a combination.',
        /**Verify multi-country numbers*/
        checkPhoneNumber1:'enter a vaild phone no.',
        checkPhoneNumber2:'enter phone no.',
        /** Verify registration password */
        checkRegisterPassword1:'enter login password',
        checkRegisterPassword2:'password containing 6-12 letters, no., or a combination.',
        /** Verify real name */
        checkrealName1:'real name not empty',
        checkrealName2:'No less than two characters',
        /** verify qq */
        checkQQ1:'QQ not empty',
        checkQQ2:'No less than six characters',
        /** Check WeChat */
        checkwechat1:' WeChat not empty',
        checkwechat2:'Not less than ten characters',
        /** Check email */
        checkemail1:'Email not empty',
        checkemail2:'Not less than 13 characters and more than 20 characters',
        checkemail3:'enter a vaild email address',
        /** Verify withdrawal password */
        checkwithdrawPassword1:'withdraw password not empty',
        checkwithdrawPassword2:'Not less than six characters',
        checkBankName:'Bank account not verified, please try later',
        /** 校验提款密码 */ 
        checkNumber1:'please input amount',
        checkNumber2:'invalid amount，please input whole number',
        checkNumber3:'amount cannot be 0',
        /** 支付金额 **/
        checkPayMoney4:'PLEAES ENTER USDT AMOUNT',
        checkPayMoney1:'PLEASE ENTER TOP UP AMOUNT',
        checkPayMoney2:' INCORRECT AMOUNT FORMAT',
        checkPayMoney3:'DEPOSIT LIMIT{min} - {max} INR',


    },
    common: {
        loading: 'loading',
        loading2: 'updating list of reward',
        search: 'search',
        tips: 'Reminder',
        congratulations: 'congratulations',
        success: 'success',
        confirmButtonText: 'confirm',
        confirmButtonText2: 'Got',
        cancelButtonText:'Cancel',
        money: 'THB',
        needLogin: 'Log in and Play',
        tryTitle:'no rewards for free bet, do you want to continue? ', 
        tryTitle2:'Sorry, this game no free bet, Log in now?',
        loginOut: 'Log out',
        close:'close',

    },
    timer: {
        finalWeek: 'last one week ',
        finalMonth: 'last one month',
        finalThreeMonth: 'last three months'

    },
    state: {
        discountsTypes: {
            all: 'all',
            rebateBonus: 'Cashback bonus',
            depositDiscount: 'deposit bonus',
            RescueFund: 'Lose Rebate',
            UpgradeAward: 'VIP upgrade bonus',
            WinningAwards: 'Retain VIP bonus',
            OtherPreferences: 'others',
            RegistrationPreferences: 'Sign up bonus'
        },
        sports_gameTypes: {
            allGame: 'all games',
            slots: 'slots',
            live: 'Live games',
            sport: 'Sports',
            lottery: 'lottery',
            fish: 'Fishing King',
            chess: 'Chess',
            other: 'other'
        }
    },
    filter: {
        status0:'Processing',
        status1:'success',
        status2:'expired',
        status3:'Cancelled',
        changeName: {
            allType: 'all types',
            applying: 'applying',
            successfulCollection: 'claimed success',
            finishFlow: 'turnover completed',
            cancel: 'decline',
            Clearance: 'Clearance',
            Unclaimed: 'Unclaimed',
            noPrize: 'not awarded',
        },
        bonusTypes: {
            Predividend: 'pre-release',
            Postdividend: 'postrelease',
            Deductdividends: 'deducted'
        },
        bonusName: {
            rebateBonus: 'Cashback bonus',
            depositDiscount: 'deposit bonus',
            Invitation: 'Referal bonus',
            signin: "Signin bonus",
            ContinuousDeposit: 'Consective deposit bonus',
            register: 'Sign up bonus',
            RescueFund: 'Lose Rebate',
            UpgradeAward: 'VIP upgrade bonus',
            WinningAwards: 'Retain VIP bonus',
            OtherPreferences: 'others',
        },
        bonusLockPlatform:{
            mineAccount: 'main account'
        },
        bonusLockStatus: {
            status1: 'Frozen',
            status2: 'Unfrozen',
            status4: 'Cancelled',
        },
        depositLockStatus: {
            status1: 'Frozen',
            status2: 'Unfrozen',
            status3: 'Frozen'
        },
        gameName:{
            name1: 'slots',
            name2: 'Live games',
            name3: 'Sports',
            name4: 'lottery',
            name5: 'Fishing King',
            name6: 'Chess',
            name7: '3D lobby',
        },
        changeTitle:{
            name0:'applying',
            name1:'system adjustment',
            name2:'Make deposits',
            name3:'quick withdraw',
            name4:'Import to game',
            name5:'Export from game',
            name6:'Freeze',
            name7:'Thaw',
            name8:'Promotion Bonus',
            name9:'Manual Deposit',
            name10:'Manual Withdraw',
            name11:"Lottery purchase",
            name12:"Lottery payouts, compulsory redemption of Yu'E Bao",
            name13:'Lottery ticket cancellation, superior agent transfer',
            name14:'Lottery daily tasks',
            name16:'Manual transfer by superior agent',
            name17:"Buy Yu'E Bao",
            name18:"Redeem Yu'E Bao",
            name19:'4D lottery purchase',
            name20:'4D Lottery Prize',
            name21:'4D lottery refund',
            name22:'Sports lottery purchase',
            name23:'Sports lottery prize',
            name24:'Sports Lottery Rollback',
            name30:'Invite promotion rebate',
            name40:'Betting',
            name41:'Payout',
            name90:'Reward',
            name91:'Guess bet',
            name92:'Guess the payout',
            name93:'Guess canceled',
            name100:'applying',
        },
        withdrawalStatus:{
            withdrawStatus0:'applying',
            withdrawStatus1:'processing',
            withdrawStatus2:'success',
            withdrawStatus3:'decline',
            withdrawStatus4:'processing',
            withdrawStatus5:'processing',
        }
    },
    catchFish: {
        in:'in',
        income:'double income',
        Deepsealive:'Deep Sea Live',
        Deepsealive2:'Real-Time Updates',
        time:'minutes ago',
        time2:'catched',
        time3:'one',
        fishKing:'Last week Fishing King',
        fishKing2:'updates every Tuesday',
    },
    invitation:{
        title:'Refer a Friend',
        title2:'Refer a friend link',
        title3:'Download App',
        copy:'copy',
        registereduser:'registed user',
        time:'time',
        InviteeStatus:'Invitation Link',
        BonusStatus:'Invitation code',
        Received:'claimed',
        receive:'claim',
        expired:'expired',
        ActivityRules:'Promotion rules:',
        ActivityRules2:'Inviter please claim a reward first so person(s)invited can earn also',
        CopySuccessful:'success copied',
        successReceived:'success claimed',
        unregistered:'अपंजीकृत',
        registered:'दर्ज कराई',

    },
    jackpot:{
        Listofwinners:'Winners',
        accountNumber:'Players list',
        game:'game',
        bonus:'bonus',
    },
    marquree:{
        Notice:'Notice',
        Close:'close',
    },
    betting: {
        title: 'betting',
        needLogin: 'You are not logged in yet!',
        AvailableBalance: 'available balance',
        betSuccess: 'success！',
        recharge: 'reload',
        inLottery: 'waiting for draw',
        rule: 'rules',
        issues: 'issue',
        rules: 'betting rules',
        betSubmit: 'place bet',
        addcart: 'add to cart',
        clear: 'clear',
        add: 'Join',
        totalTxt: 'total',
        noselected: 'select lucky numbers!',
        noEnoughMoney: 'no enough balance',
        Count:'Count',
        Amount:'Amount',
        betNow:'place bet',
        Total:'Total',
        return:'Return',
        TotalCount:'Total Count',
        TotalAmount:'Total Amount',
        TotalWinLost:'Win/Lost',
        date:'Date',
        settleType: {
            all: 'All',
            Bets:'Bets',
            noSettle: 'Unsettle',
            settle: 'Settled',
            win: 'win',
            lose: 'lose',
            refund: 'Principal refund',
            PlaceBets:'Place Bets',
            ClearAll:'Clear All',
            cost:'cost',
            NumberofBets:'Number of Bets',
            tips:'Reminder: The current page only displays the betting records of GT Cricket, BTI, IBC, EXCHANGE betting records, please check in Other Games',
        },
        trafficList: {
          0: 'Number',
          10: 'Red',
          12: 'Blue',
          11: 'Yellow',
        },
        cartHead: {
            type: 'type',
            details: 'details',
            // multiple: 'multiple',
            money: 'amount'
        },
        lotteryTab: {},
        countDown: '距下一期',
        record: {
            title1: 'draw history',
            title2: 'my betting history',
            title: 'betting details',
            orderNo: 'tickets number',
            betMoney: 'bet amount',
            dealMoney: 'Amount',
            serviceAmount: 'service fee',
            drawNum: 'draw number',
            betNum: 'bet number',
            status: 'status',
            rewards: 'rewards',
            betTime: 'betting time',
            tableHead: {
              Period: 'Tier',
              Price: 'jackpot',
              Numbers: 'draw numbers',
              Result: 'results'
            },
        }
    },
    createdDislaog:{
        diaTitle:'Welcome',
        signTitle:'CREATE A FREE ACCOUNT',
        sigupSuccess:'WELCOME!',
        staytuned:'Stay Tuned',
        prove:'enter digits or letters, with only one space in between',
        Announcement:"Announcement"
        
    },
    wheel:{
        WinningRecord:'My winning record',
        Remaining:'Remaning lucky draw',
        Times:'Times',
        Start:'Start',
        NoWinningRecord:'No winning record',
        Loading:'Loading...',
        Delivered:'Delivered',
        service:'Service',
        GoodLuck:'Good luck, win',
        prize:'Grand prize',
        HurryReceive:'Hurry up and contact customer service to receive it',
        BONUS:'Reward sent. Please check the transaction record',
        remainingtimes:'Your remaining lottery is 0 times',
        Iknow:'I know',
        determine:'confirm',
        cancel:'cancel',
        confirm:' Warm Reminder',
        message:'Lucky Draw is ongoing, please don’t click frequently!',
    },
    IPL:{
        TotalBit:'Total output of 11ic coins',
        myBit:'My 11ic coins',
        myBonus:'My Bonus',
        rank:'rank',
        Details:'Details',
        Claim:'Claim',
        subTitle:'Rs. 10 million / Total 11ic coins * My 11ic coin',
        Rank:{
            myRank:'My Rank:',
            title:'TOP 20 RANKING'
        },
        bet:{
            title1:'Win more using 11ic coins',
            MyBets:'My Bets',
            title2:'Place bets on your chosen winning team and earn coins',
            betslip:'Betslip',
            Winner:'Winner',
            BetAmount:'Bet Amount',
            Mycoin:'My 11ic coin balance:',
            noselected:'select team!',
            noamount:'Enter betting amount',
            noEnoughMoney:'no enough coin!'
        },
        CP:{
            title1:'Predict the Champion',
            title2:'Predict the Chamption and win xxx 11ic coins',
            YourChampion:'Your Champion',
            Confim:'Confim'
        },
        TW:{
            title1:'Exchange Daily Turnover to 11ic Coins',
            days:'Days of Betting',
            orders:'No. betting orders',
            amounts:'Betting amount',
            bits:'Convert 11ic coins',
            Eover:'The event is over',
        },
        IE:{
            title:'Invite Friend to earn 11ic coins',
            title2:'Invite Friends, Earn 11ic Coins Daily!',
            InvitationLink:'Invitation Link',
            App:'Download App',
            code:'Invitation code',
            Register:'Register',
            Vircation:'Verified',
            getBonus:'Get 11ic coins',
        },
        SE:{
            title1:'Earn 11ic coins by sharing us on your social media accounts.',
            title2:'Share the image or the link by copying and pasting it in your',
            title3:'social media accounts. (POST MUST BE PUBLIC)',
            title4:'Participate in IPL tournaments to win Rs.10 million prize pool ！',
            Link:'Visit Link',
            reward:'11ic coins reward',
            How:'How to claim？',
            tips:'Take a screenshot of your shared post and contact customer service to earn 11ic Coins. Coins will be issued to your account once review is approved.',
            
        },
        Record:{
            BetA:'Betting Amount',
            Total:'Total 11ic coins earn',
            WR:'Win/Loss',
            Invite_:'Invite',
            ChampionPrediction:{
                Waiting:'Waiting for settlement',
                Noyet:'No results yet',
                Yc:'Your Champion',
                items:{
                    Bonus:'11ic Coin Bonus',
                    time:'Prediction Time',
                    Result:'Result',
                    Predict:'Predict your champion'
                },
                status: {
                    '0': "Waiting for results",
                    '1': "Win",
                    '2': "Failed",
                },
            },
            TotalWager:{
                amount:'Bet amount',
                recived:'11ic coins recived',
            },
            Share:{
                reward:'11ic coins reward',
                status:{
                    '0': "Waiting to claim",
                    '1': "Success",
                    '2': "Failed",
                }
            },
            Invite:{
                User:'User Name',
                Bonus:'11ic Coin Bonus',
                time:'Register Time',
            },
        },
    },
    ghistory: {
		title: 'Bet Detail',
		Playerid: 'Player ID',
		gameid: 'Game ID',
		insurance: 'insurance',
		WinorLoss: 'Total win/loss',
		betTime: 'Bet time:',
		orderNo: 'Txn. ID',
		Status: 'Status',
		Provider: 'Provider',
		Event: 'Event',
		betArea: 'Bet area',
        gameName: 'Game name',
		total: "Total",
		Odds: 'Odds',
		TotalBets: 'Total Bets',
		ValidBets: 'Valid Bets',
		WinorLoss2: 'Win/Loss',
		close: 'close',
		Running: 'Running',
        Settled: 'Settled',
        Game: 'Game',
	},
    ...enLocale
}
export default en_US


// WEBPACK FOOTER //
// ./src/pages/build902/i18n/langs/en_US.js